import React, { useState } from 'react';

import { Link } from "react-router-dom";
import { generalS } from '../strings/general';
import logo from "../imgs/favicon.png";
import "../styles/css/pagenotfound.css";
import "../styles/css/main.css";
import "../styles/css/home.css";

export default function LatestProject({ context }) {

  let { language } = context;
  return (
    <dvi className={"wrapper"}>
      <div className={"page-not-found-container"}>
        <h1 className={"page-not-found-title"}>{404}</h1>
        <p className={"page-not-found-detail"}>{generalS.pageNotFound[language]}</p>
        <div className={"page-not-found-imge-container"}>
          <img src={logo} />
        </div>
        
        <div className={"home-card-link-content"}>
            <Link to={`/`} className={"home-card-link"}>
              {generalS.backToHome[language]}
            </Link>
          </div>
      </div>
    </dvi>
  );
}
